import Api from './Api';
import Cookie from 'js-cookie';
import axios from 'axios'

export default {
    Register(email, password, firstName, lastName, companyName, success, fail) {
        
        var payload = {
            FirstName: firstName,
            LastName: lastName,
            Email: email,
            Password: password,
            CompanyName: companyName
        };

        Api.post(process.env.SIGNUP_WORKFLOW_ENDPOINT, payload)
            .then((response) => {
                debugger;
                if(response.data.Data.Error) {
                    fail(response.data.Data);
                }
                else {
                    success(response.data.Data.Result);
                    // this.GetUserDetails(email, password).then(
                    //     (detailsResponse) => {
                    //         success(detailsResponse.data);
                    //     }
                    // );
                }
            })
            .catch(function (error) {
                console.log(error);

            });
    },
    GetUserDetails() {
        return Api.get(process.env.CUSTOMER_PROFILE_API_ENDPOINT);
    },
    ForgotPassword(username) {
        var payload = {
            username: username
        };

        return Api.post(process.env.FORGOT_PASSWORD_WORKFLOW_ENDPOINT, payload);
    },
    Authenticate(username, password) {
        var payload = {
            username,
            password
        };

        return axios.post(process.env.TOKEN_ENDPOINT, payload, { withCredentials: true })

        //return Api.post(process.env.TOKEN_ENDPOINT, payload);
    },
    GetRoles() {
        var headerpayload = Cookie.get('JWThp');
        var split = headerpayload.split('.');
        var payload = split[1];
        var decoded = atob(payload);
        var jwt = JSON.parse(decoded);
        if(Array.isArray(jwt.role)) {
            return jwt.role;
        }
        else{
            return [jwt.role];
        }
        
    }
}


// WEBPACK FOOTER //
// ./src/services/AuthService.js